
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

interface CalendarNavigationProps {
  currentMonth: Date;
  onNavigateMonth: (direction: 'prev' | 'next') => void;
  isLoading: boolean;
}

const CalendarNavigation: React.FC<CalendarNavigationProps> = ({
  currentMonth,
  onNavigateMonth,
  isLoading
}) => {
  return (
    <div className="flex items-center justify-between mb-4">
      <Button
        variant="outline"
        size="sm"
        onClick={() => onNavigateMonth('prev')}
        disabled={isLoading}
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      
      <h3 className="text-lg font-semibold text-gray-800 capitalize">
        {format(currentMonth, "MMMM 'de' yyyy", { locale: ptBR })}
      </h3>
      
      <Button
        variant="outline"
        size="sm"
        onClick={() => onNavigateMonth('next')}
        disabled={isLoading}
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default CalendarNavigation;
